import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-399cee12")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_prism = _resolveComponent("prism")!

  return (_openBlock(), _createBlock("section", {
    class: ["module line-numbers", [ _ctx.module.type ]]
  }, [
    _createVNode(_component_prism, {
      "data-line": _ctx.module.moduleHighlightedLine,
      language: _ctx.module.moduleLanguage
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.module.moduleCode), 1)
      ]),
      _: 1
    }, 8, ["data-line", "language"])
  ], 2))
})